<template>
  <auth-layout :heading="$t('heading')">
    <v-alert
      v-if="updateEmailError"
      :value="true"
      type="error">
      {{ $t('updateError') }}
    </v-alert>
    <v-progress-linear
      v-else
      :indeterminate="true"/>

    <v-btn
      v-if="updateEmailError"
      slot="navigation"
      :to="{name: 'login'}"
      flat
    >
      {{ $t('home') }}
    </v-btn>
  </auth-layout>
</template>

<script>
import UserApi from '@/api/UserApi'
import AuthLayout from '@/components/layouts/AuthLayout'

export default {
  name: 'EmailUpdateConfirm',
  components: { AuthLayout },
  data () {
    return {
      updateEmailError: false
    }
  },
  methods: {
    redirectToLogin () {
      setTimeout(_ => {
        this.$router.push({ name: 'login' })
      }, 2000)
    }
  },
  async created () {
    try {
      await this.$notification(await UserApi.updateEmailConfirm({ hash: this.$route.query.hash }))
      this.redirectToLogin()
    } catch (e) {
      this.updateEmailError = true
      await this.$notification(e)
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Update Email',
        updateError: 'Es ist ein Fehler aufgetreten',
        home: 'Zurück'
      },
      en: {
        heading: 'Update Email',
        updateError: 'An error occured',
        home: 'Back'
      },
      tr: {
        heading: 'E-posta Güncelleme',
        updateError: 'Bir hata oluştu',
        home: 'Geri'
      },
      ru: {
        heading: 'Изменить эл. почту',
        updateError: 'Произошла ошибка изменения',
        home: 'Назад'
      }
    }
  }
}
</script>
